(function(){
  let colorSwitchersWrapper = document.querySelectorAll(`.ProductItem__ColorSwatchList`),
      screenWidth = 767,
      desktopBubbleCount = 6,
      mobileBubbleCount = 3;


  document.addEventListener('products:loading:end', function(){
      let colorSwitchersWrapper = document.querySelectorAll('.ProductItem__ColorSwatchList');
      hideColorSwitchers(colorSwitchersWrapper);
      appendColorSwitchersCount(colorSwitchersWrapper);
  });
  document.addEventListener("DOMContentLoaded", function() {
    hideColorSwitchers(colorSwitchersWrapper);
    appendColorSwitchersCount(colorSwitchersWrapper);
  });
  window.addEventListener('resize', function (e) {
    showColorSwitchers(colorSwitchersWrapper);
    hideColorSwitchers(colorSwitchersWrapper);
    appendColorSwitchersCount(colorSwitchersWrapper);
  });
  function hideColorSwitchers(colorSwitchersWrapper){
    if(colorSwitchersWrapper){
      colorSwitchersWrapper.forEach(item => {
        let colorSwitchers = item.querySelectorAll('.ProductItem__ColorSwatchItem');

        for(let i = 0, l = colorSwitchers.length; i < l; i++){
          if(i >= desktopBubbleCount && window.innerWidth > screenWidth){
            colorSwitchers[i].style.display = 'none';
          }
          if(i >= mobileBubbleCount && window.innerWidth <= screenWidth){
            colorSwitchers[i].style.display = 'none';
          }
        }
      })
    }
  }
  function showColorSwitchers(colorSwitchersWrapper){
    if(colorSwitchersWrapper){
      colorSwitchersWrapper.forEach(item => {
      let colorSwitchers = item.querySelectorAll('.ProductItem__ColorSwatchItem');
        for(let i = 0, l = colorSwitchers.length; i < l; i++){
          colorSwitchers[i].style.display = 'inline-block';
        }
      })
    }
  }
  function appendColorSwitchersCount(colorSwitchersWrapper){
    if(colorSwitchersWrapper){
      colorSwitchersWrapper.forEach(item => {
        let colorSwitchers = item.querySelectorAll('.ProductItem__ColorSwatchItem'),
            countDivElement  = item.querySelector('.switchers-count');

        if(countDivElement)
          countDivElement.remove();
        countDiv = document.createElement('div');
        countDiv.className = 'switchers-count';
        if(colorSwitchers.length > desktopBubbleCount && window.innerWidth > screenWidth){
          countDiv.innerHTML = '+' + (colorSwitchers.length - desktopBubbleCount);
          item.appendChild(countDiv);
        }
        else if(colorSwitchers.length > mobileBubbleCount && window.innerWidth <= screenWidth){
          countDiv.innerHTML = '+' + (colorSwitchers.length - mobileBubbleCount);
          item.appendChild(countDiv);
        }
    })
    }
  }
})();
